import { memo } from 'react';
import { Node, NodeProps } from '@xyflow/react';
import { AircraftIcon } from '@icons';
import { RouteNodeType } from '@lp/features/RoutePlanner/types';
import { NodeHandleConnections } from './NodeHandleConnections';

export type AirportNodeProps = Node<RouteNodeType['data'], 'airportNode'>;

export const AirportNode = memo(({ data }: NodeProps<AirportNodeProps>) => {
  return (
    <NodeHandleConnections>
      <div className="flex justify-center items-center bg-transparent gap-1 border-1 border-base-30 pl-0 pr-0.5 rounded-sm text-base-30">
        <AircraftIcon width={12} height={12} />
        <span className="font-mono text-s-sb uppercase">{data.title}</span>
      </div>
    </NodeHandleConnections>
  );
});
